export const DEMO_PAGE_TRACKED_PATHS: string[] = [
  '/demo',
  '/demo/pay-and-go',
  '/demo/payment-flow',
];
